// Rotates a search input's placeholder through comma-separated phrases.
// Stays on the first phrase in the theme editor and for reduced-motion users.
if (!customElements.get('rotating-placeholder')) {
  customElements.define(
    'rotating-placeholder',
    class RotatingPlaceholder extends HTMLElement {
      connectedCallback() {
        const input = document.getElementById(this.dataset.for);
        const phrases = this.dataset.phrases
          .split(',')
          .map((phrase) => phrase.trim())
          .filter(Boolean);
        if (!input || phrases.length < 2) return;
        if (Shopify.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        let index = 0;
        this.timer = setInterval(() => {
          index = (index + 1) % phrases.length;
          input.placeholder = phrases[index];
        }, 2500);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }
    }
  );
}
